import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "core/redux/store/store";
import { formStep, personalAreaStep } from "types/StepEnums";

// import { fetchSession } from "./sessionAPI";
import { ISessionData, ISessionState } from "./sessionSliceInterfaces";

const initialState: ISessionState = {
	data: {
		sessione: undefined,
		step: formStep.Home,
		isLogged: false,
		nominativoUtente: undefined,
		tokenFCM: undefined,
		changePasswordRequired: false,
	},
	status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// commentato perchè non in uso $ALC
// export const incrementAsync = createAsyncThunk("session/fetchSession", async (Session: ISessionData) => {
// 	const response = await fetchSession(Session);
// 	// The value we return becomes the `fulfilled` action payload
// 	return response.data;
// });

export const sessionSlice = createSlice({
	name: "session",
	initialState,
	// The `reducers` field lets us define reducers and generate associated actions
	reducers: {
		setSession: (state: ISessionState, action: PayloadAction<ISessionData | undefined>) => {
			var newSession: ISessionData | undefined;
			if (action.payload) newSession = { idSessione: action.payload!.idSessione, expiredIn: action.payload?.expiredIn };
			state.data.sessione = newSession;
		},

		setIdSessione: (state: ISessionState, action: PayloadAction<string>) => {
			if (state.data.sessione) state.data.sessione.idSessione = action.payload;
		},

		setStep: (state: ISessionState, action: PayloadAction<formStep | personalAreaStep>) => {
			if (action.payload !== state.data.step) state.data.step = action.payload;
		},
		setLogged: (state: ISessionState, action: PayloadAction<boolean>) => {
			state.data.isLogged = action.payload;
		},
		setNominativoUtente: (state: ISessionState, action: PayloadAction<string | undefined>) => {
			state.data.nominativoUtente = action.payload;
		},
		setTokenFCM: (state: ISessionState, action: PayloadAction<string | undefined>) => {
			state.data.tokenFCM = action.payload;
		},

		setChangePasswordRequired: (state: ISessionState, action: PayloadAction<boolean>) => {
			state.data.changePasswordRequired = action.payload;
		},

		resetLogin: (state: ISessionState) => {
			state.data.isLogged = false;
			state.data.nominativoUtente = undefined;
			state.data.tokenFCM = undefined;
		},
		setLogin: (state: ISessionState, action: PayloadAction<[boolean, string | undefined]>) => {
			state.data.isLogged = action.payload[0];
			state.data.nominativoUtente = action.payload[1];
		},

		resetSession: (state: ISessionState) => {
			state.data.sessione = undefined;
			state.data.step = formStep.Home;
			state.data.isLogged = false;
			state.data.nominativoUtente = undefined;
			state.data.tokenFCM = undefined;
		},
	},
	// The `extraReducers` field lets the slice handle actions defined elsewhere,
	// including actions generated by createAsyncThunk or in other slices.
	// commentato perchè non in uso $ALC
	// extraReducers: (builder) => {
	// 	builder
	// 		.addCase(incrementAsync.pending, (state) => {
	// 			state.status = "loading";
	// 		})
	// 		.addCase(incrementAsync.fulfilled, (state, action) => {
	// 			state.status = "idle";
	// 			state.data.sessione = action.payload;
	// 		})
	// 		.addCase(incrementAsync.rejected, (state) => {
	// 			state.status = "failed";
	// 		});
	// },
});

export const {
	setIdSessione,
	setStep,
	resetSession,
	setLogged,
	setSession,
	setNominativoUtente,
	resetLogin,
	setLogin,
	setTokenFCM,
	setChangePasswordRequired,
} = sessionSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectSession = (state: RootState) => state.session.data;

// // We can also write thunks by hand, which may contain both sync and async logic.
// // Here's an example of conditionally dispatching actions based on current state.
// export const moveStep =
// 	(move: move): AppThunk =>
// 	(dispatch, getState) => {
// 		const currentValue = selectSession(getState());
// 		if (move === "next") {
// 			dispatch(setStep(currentValue.step + 1));
// 		} else if (move === "prev" && currentValue.step > 0) {
// 			dispatch(setStep(currentValue.step - 1));
// 		}
// 	};

export default sessionSlice.reducer;
